module.exports = __webpack_public_path__ + "img/Blizzert_ticket_info_KARAOKE_text_layer.9d549b98.png";